import { render, staticRenderFns } from "./BloodMorphologyMgr.vue?vue&type=template&id=1b8628fc"
import script from "./BloodMorphologyMgr.vue?vue&type=script&lang=js"
export * from "./BloodMorphologyMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports